import React, { useContext, useEffect, useState } from "react";
import Application from "../../../StateContext/Application.js";
import {
  SendBack32,
  Approved32,
  BudgetHeadCreationBlue32,
  Cancel32,
  DeleteRed32,
  EditBlueBlue32,
  submit,
  Tax32,
  UpdateWhite32,
  EditIcon,
  DeleteIcon,
  Edit32WHITE,
  Delete32WHITE,
  Excel32,
  JPG32,
  PNG32,
  PDF32,
} from "../../../../../public/LoginImages/importimages";
import { apiurl } from "../../../../../path";
import BudgetEstimation from "../BudgetEstimation/BudgetEstimation.js";
const BudgetEstimationInwardList = () => {
  const operation = useContext(Application);
  const { Usermenu, GetBudgetEstimationList, BudgetEstimationApproval } =
    operation;

  const [budgetEstimation, setBudgetEstimation] = useState([]);
  const [loading, setLoading] = useState(false);
  const [SelectedOptions, setSelectedOptions] = useState("Pending");
  const [selectedBills, setSelectedBills] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [rejectPanelhide, setRejectpanelhide] = useState(1);
  const [remark, setRemark] = useState("");
  const [showEditForm, setShowEditForm] = useState(false);
  const [menuData, setMenuData] = useState(null);
  const [editBudgetEstimationData, setEditBudgetEstimationData] =
    useState(null);
  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);
  console.log("currentbills", currentBills);

  useEffect(() => {
    const getMenu = async () => {
      const res = await Usermenu();
      console.log("menuData", res);
      console.log(res);
      setMenuData(res?.Data || {});
    };

    getMenu();
  }, []);
  const isMaker =
    menuData?.Department_Name === "State Maker" &&
    menuData?.Role === "State Maker";

  const isChecker =
    menuData?.Department_Name === "State Checker" &&
    menuData?.Role === "State Checker";
  console.log("menuData", menuData);

  useEffect(() => {
    BudgetEstimationList();
  }, []);

const BudgetEstimationList = async () => {
  try {
    let res = await GetBudgetEstimationList();
    console.log("res", res);
 
    const data = res?.result || [];
 
    // Latest added record first
    const latestFirst = [...data].reverse();
 
    setFilteredBills(latestFirst);
    setBudgetEstimation(latestFirst);
    setCurrentPage(1);
  } catch (err) {
    console.log(err);
  }
};
  const handleCheckboxChange = (id) => {
    setSelectedBills((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((billId) => billId !== id)
        : [...prevSelected, id],
    );
  };
  console.log("Slected id form table :: ", selectedBills);
  console.log("Filtered data id form table :: ", filteredBills);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedBills(currentBills.map((bill) => bill.ID));
    } else {
      setSelectedBills([]);
    }
  };

  const approveorrejectSelected = async (condition) => {
    if (selectedBills.length === 0) {
      alert("No Budget Estimation selected for approval!");
      return;
    }
    console.log(selectedBills);
    setLoading(true);
    let shouldStart = window.confirm("Are you sure ???");

    if (shouldStart) {
      try {
        let response = await BudgetEstimationApproval(
          selectedBills,
          condition,
          remark,
        );
        if (response.message) {
          alert(response.message);
          setRejectpanelhide(0);
          setRemark("");
          setLoading(false);
          window.location.reload();
        }
        if (response.error) {
          alert(response.error);
          setRejectpanelhide(0);
          setRemark("");
          setLoading(false);
          window.location.reload();
        }
      } catch (error) {
        console.error("Error approving Proposal:", error);
        alert("An error occurred while approving bills.");
        setRejectpanelhide(0);
        setLoading(false);
        setRemark("");
        window.location.reload();
      }
    } else {
      alert(`Project ${condition} Operation Cancelled !!!`);
      setRemark("");
      setRejectpanelhide(0);
      window.location.reload();
    }
    setLoading(false); // Stop loader
  };

  const rejectSendbackbeforecheckup = (id) => {
    if (selectedBills.length > 0) {
      setRejectpanelhide(id);
    } else {
      alert("No BudgetEstimation Selected !!!");
    }
  };
  useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    const filtered = budgetEstimation.filter((bill) =>
      Object.values(bill).some((val) =>
        (val || "").toString().toLowerCase().includes(lowerSearchTerm),
      ),
    );
    setFilteredBills(filtered);
    setCurrentPage(1); // Reset to page 1 on search
  }, [searchTerm, budgetEstimation]);


   
    const getPageNumbers = (currentPage, totalPages) => {
        const maxVisiblePages = 5;
 
       
        if (totalPages <= maxVisiblePages) {
            return Array.from(
                { length: totalPages },
                (_, index) => index + 1
            );
        }
 
        // Starting pages
        // 1 2 3 4 5 ... Last
        if (currentPage <= 3) {
            return [1, 2, 3, 4, 5, "...", totalPages];
        }
 
        // Last pages
        // ... 16 17 18 19 20
        if (currentPage >= totalPages - 2) {
            return [
                "...",
                totalPages - 4,
                totalPages - 3,
                totalPages - 2,
                totalPages - 1,
                totalPages
            ];
        }
 
        // Middle pages
        // ... 4 5 6 7 8 ... 20
        return [
            "...",
            currentPage - 2,
            currentPage - 1,
            currentPage,
            currentPage + 1,
            currentPage + 2,
            "...",
            totalPages
        ];
    };
 
  return (
    <>
      {!showEditForm ? (
        <>
          <div
            className="col-12"
             style={{
              backgroundColor: "#ffffff",
              height: "90vh",
              overflowX: "hidden",
              overflowY: "scroll",
              //29/10
                padding: "15px 20px",     
    boxSizing: "border-box",
            }}
          >
                <div
  style={{
    background: "#EEF2F7",
    border: "1px solid #dfe5ee",
    borderRadius: "10px",
    padding: "20px 20px 20px",
    width: "100%",
    boxSizing: "border-box",
  }}
>
              <div
                className="col-12 px-4 mb-4 mt-3"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h5 className="my-auto fw-bold">
                  {/* <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' /> */}
                  <img
    src="/Project-Inward-List-32.png"
    alt="img"
   
  /> <span className="my-auto">Budget Estimation Inward List</span>
                </h5>

                <div
                  style={{
                    position: "relative",
                    width: "250px",
                    marginRight: "10px",
                  }}
                >
                  <img
                    src="/Search32.png"
                    alt="Search Icon"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "10px",
                      transform: "translateY(-50%)",
                      width: "16px",
                      height: "16px",
                      opacity: 0.6,
                    }}
                  />
                  <input
                    type="text"
                    placeholder="Search Here"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "8px 12px 8px 32px", // left padding makes space for icon
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      backgroundColor: "#ffffff",
                      fontSize: "14px",
                      color: "#333",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                      outline: "none",
                    }}
                  />
                </div>
              </div>

              {loading && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(255, 255, 255, 0.7)",
                    backdropFilter: "blur(4px)",
                    zIndex: 9999,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      border: "6px solid #f3f3f3",
                      borderTop: "6px solid #007bff",
                      borderRadius: "50%",
                      width: "60px",
                      height: "60px",
                      animation: "spin 1s linear infinite",
                    }}
                  />
                  <style>
                    {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                  </style>
                </div>
              )}

              <div
                className="m-auto mb-3"
               style={{
                            backgroundColor: "#ffffff",
                            padding: "14px 18px 10px",
                            boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
                            borderRadius: "12px",
                            width: "100%",
                            boxSizing: "border-box",
                            overflow: "hidden"
                        }} >
                <div
                  className="col-12 tableDesign"
                  style={{
    background: "#ffffff",
    marginTop: "4px",
    overflowX: "auto",
    overflowY: "hidden",          
    // maxHeight: "360px",        
    border: "1px solid #d9e1f2",
    borderRadius: "8px",
    boxSizing: "border-box",
    scrollbarWidth: "thin",
  }}>
                  {SelectedOptions === "Pending" && (
                    <table
                      className="m-0 p-0"
  style={{
    width: "100%",
    minWidth: "950px",
    borderCollapse: "separate",   
    borderSpacing: 0,             
    tableLayout: "auto",
  }}  >
                      <thead>
                        <tr
                           style={{
                            //28/10
                                                    backgroundColor: "#2D79D9",
                                                    color: "white",
                                                    border: "none",
                                                    height: "34px",
                                                    fontSize: "14px",
                                                    fontWeight: "600",
                                                    textAlign: "center",
                                                    whiteSpace: "nowrap"
                                                }} >
                             <th style={{ minWidth: "50px", padding: "8px" }}>
                            <input
                              type="checkbox"
                              onChange={handleSelectAll}
                              checked={
                                currentBills.length > 0 &&
                                currentBills.every((bill) =>
                                  selectedBills.includes(bill.ID),
                                )
                              }
                              className="my-auto"
                              style={{ height: "1rem", width: "1rem" }}
                            />
                          </th>
                          <th style={{ padding: "10px" }}>Sr.No</th>
                          <th style={{ padding: "10px" }}>Project ID</th>
                          <th style={{ padding: "10px" }}>Project Name</th>
                          <th style={{ padding: "10px" }}>Financial Year</th>
                          <th style={{ padding: "10px" }}>Budget ID</th>
                          <th style={{ padding: "10px" }}>CRC</th>
                          <th style={{ padding: "10px" }}>Budget Head</th>
                          <th style={{ padding: "10px" }}>Object Code</th>
                          <th style={{ padding: "10px" }}>Esitmate Amount</th>
                          <th style={{ padding: "10px" }}>Date</th>
                         {isMaker && ( <th style={{ padding: "10px" }}>Remark</th> )}
                           {isMaker && (
                            <th style={{ padding: "10px" }}>Action</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {currentBills.length <= 0 ? (
                          <tr>
                            <td
                              colSpan="12"
                              style={{
                                textAlign: "center",
                                padding: "15px 10px",
                                backgroundColor: "#f9f9f9",
                              }}
                            >
                              No data available
                            </td>
                          </tr>
                        ) : (
                          currentBills?.map((budgetEstimation, index) => {
                            const bgColor =
                              index % 2 === 0 ? "#E5F4FB" : "#CEE4F1";
                            return (
                              <tr
                                style={{
                                  backgroundColor: bgColor,
                                  fontSize: "13px",
                                  fontWeight: "500",
                                }}
                                key={index}
                              >
                                
                                <td style={{ textAlign: "center" }}>
                                  <input
                                    type="checkbox"
                                    className="my-auto"
                                    style={{textAlign:"center"}}
                                    // checked={selectedBills.includes(budgetEstimation.ProjectID)}
                                    // onChange={() => handleCheckboxChange(budgetEstimation.ProjectID)}
                                    checked={selectedBills.includes(
                                      budgetEstimation.ID,
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange(budgetEstimation.ID)
                                    }
                                  />
                                </td>
                                <td
                                  style={{
                                    padding: " 7px 10px ",
                                    textAlign: "center",
                                    verticalAlign:"center"
                                  }}
                                >
                                  {indexOfFirstBill + index + 1}
                                </td>
                               
                                <td  style={{
                                    padding: " 7px 10px ",
                                    textAlign: "center",
                                    verticalAlign:"center"
                                  }}>
                                  {budgetEstimation.ProjectID}
                                </td>
                                <td  style={{
                                    padding: " 7px 10px ",
                                    textAlign: "center",
                                    verticalAlign:"center"
                                  }}>
                                  {budgetEstimation.ProjectName}
                                </td>
                                <td  style={{
                                    padding: " 7px 10px ",
                                    textAlign: "center",
                                    verticalAlign:"center"
                                  }}>
                                  {budgetEstimation.Year}
                                </td>
                                <td  style={{
                                    padding: " 7px 10px ",
                                    textAlign: "center",
                                    verticalAlign:"center"
                                  }}>
                                  {budgetEstimation.BudgetID}
                                </td>
                                <td  style={{
                                    padding: " 7px 10px ",
                                    textAlign: "center",
                                    verticalAlign:"center"
                                  }}>
                                  {budgetEstimation.CRC}
                                </td>
                                <td  style={{
                                    padding: " 7px 10px ",
                                    textAlign: "center",
                                    verticalAlign:"center"
                                  }}>
                                  {budgetEstimation.BudgetHead}
                                </td>
                                <td  style={{
                                    padding: " 7px 10px ",
                                    textAlign: "center",
                                    verticalAlign:"center"
                                  }}>
                                  {budgetEstimation.ObjectCode}
                                </td>
                                <td  style={{
                                    padding: " 7px 10px ",
                                    textAlign: "center",
                                    verticalAlign:"center"
                                  }}>
                                  {/* {budgetEstimation.EsitmateAmount} */}
                                  ₹{Number(budgetEstimation.EsitmateAmount || 0).toLocaleString("en-IN")}
                                </td>
                                <td  style={{
                                    padding: " 7px 10px ",
                                    textAlign: "center",
                                    verticalAlign:"center"
                                  }}>
                                  {budgetEstimation.Date?.split("T")[0].replace(
                                    " ",
                                  )}
                                </td>
                               {isMaker && ( <td  style={{
                                    padding: " 7px 10px ",
                                    textAlign: "center",
                                    verticalAlign:"center"
                                  }}>
                                  {budgetEstimation.Remark}
                                </td> )}
                                 {isMaker && (
                                  <td
                                     style={{
                                    padding: " 7px 10px ",
                                    textAlign: "center",
                                    verticalAlign:"center"
                                  }}
                                  >
                                    <button
                                      onClick={() => {
                                        console.log(
                                          "Selected Estimagte For Edit:",
                                          budgetEstimation,
                                        );
                                        setEditBudgetEstimationData(
                                          budgetEstimation,
                                        );
                                        setShowEditForm(true);
                                      }}
                                      style={{
                                        border: "none",
                                        background: "transparent",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <img
                                        src={EditIcon}
                                        alt="Edit"
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                        }}
                                      />
                                    </button>
                                  </td>
                                )}
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  )}
                </div>

                <div className="col-12 mt-3">
                  <div className="row">
                    <div
                      className="col-6 text-start"
                      style={{ display: "flex", justifyContent: "left" }}
                    >
                      <button
                        onClick={() => approveorrejectSelected("Approved")}
                        disabled={selectedBills.length <= 0 ? true : loading}
                        className="ms-0"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.3rem",
                          margin: "12px",
                          padding: "8px 10px",
                          fontWeight: "600",
                            backgroundColor:
                                                selectedBills.length <= 0
                                                    ? "#f3eeee"
                                                    : "#39B54A",
 
                                            color: selectedBills.length > 0 ? "#ffffff" : "#01B574",
                                            border: "1px solid #39B54A",
                          color: selectedBills.length > 0 ? "#ffffff" : "#01B574",
                          borderRadius: "8px",
                          cursor:
                            selectedBills.length <= 0
                              ? "not-allowed"
                              : loading
                                ? "not-allowed"
                                : "pointer",
                        }}
                      >
                         <img
                                            src={Approved32}
                                            alt="Approve"
                                            style={{
                                                width: '18px',
                                                height: '18px'
                                            }}
                                        />{" "}
                        {loading ? "Processing..." : "Approve Selected"}
                      </button>

                      {isChecker && (
                        <button
                          onClick={() => rejectSendbackbeforecheckup(2)}
                          disabled={selectedBills.length <= 0 ? true : loading}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.3rem",
                            margin: "12px",
                            padding: "8px 10px",
                            fontWeight: "600",
                             backgroundColor: selectedBills.length <= 0 ? "#f3eeee"  : "#C1272D",
                              color: selectedBills.length > 0 ? "#ffffff" : "red",
                              border: "1px solid #ff6b81",
                           color: selectedBills.length > 0 ? "#ffffff" : "red",
                            borderRadius: "8px",
                            cursor:
                              selectedBills.length <= 0
                                ? "not-allowed"
                                : loading
                                  ? "not-allowed"
                                  : "pointer",
                          }}
                        >
                          <img
                          src={DeleteRed32}
                          alt="Reject"
                          style={{
                            width: '18px', height: '18px', filter: selectedBills.length > 0
                              ? 'brightness(0) invert(1)'
                              : 'none'
                          }} />{" "}
                          {loading ? "Processing..." : "Reject Selected"}
                        </button>
                      )}

                      {isChecker && (
                        <button
                          onClick={() => rejectSendbackbeforecheckup(3)}
                          disabled={selectedBills.length <= 0 ? true : loading}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "3px",
                            margin: "12px",
                            padding: "8px 10px",
                            fontWeight: "600",
                            // background:
                            //   selectedBills.length <= 0
                            //     ? "rgba(141, 141, 141, 0.97)"
                            //     : "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
                            // color: "white",
                            backgroundColor:
      selectedBills.length <= 0
        ? "#f3eeee"
        : "blue",
    border: "1px solid blue",
    color:
      selectedBills.length > 0
        ? "white"
        : "blue",
                            borderRadius: "8px",
                            cursor:
                              selectedBills.length <= 0
                                ? "not-allowed"
                                : loading
                                  ? "not-allowed"
                                  : "pointer",
                          }}
                        >
                         <img
  src={SendBack32}
  alt="Send Back"
  style={{
    width: "18px",
    height: "18px",
    flexShrink: 0,
    filter: selectedBills.length > 0
        ? "brightness(0) invert(1)"
        : "invert(28%) sepia(99%) saturate(7486%) hue-rotate(230deg) brightness(89%) contrast(128%)",
  }}
/>{" "}
                          {loading ? "Processing..." : "Send Back Selected"}
                        </button>
                      )}
                    </div>

                        <div
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        marginTop: "15px",
                                        padding: "10px 5px",
                                        boxSizing: "border-box",
                                    }}
                                >
                                    {/* Showing Entries */}
                                    <div
                                        style={{
                                            fontSize: "13px",
                                            color: "#333",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        Showing{" "}
                                        {filteredBills?.length === 0
                                            ? 0
                                            : indexOfFirstBill + 1}{" "}
                                        to{" "}
                                        {Math.min(
                                            indexOfLastBill,
                                            filteredBills?.length || 0
                                        )}{" "}
                                        of {filteredBills?.length || 0} entries
                                    </div>
 
                                    {/* Pagination Right Side */}
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "18px",
                                        }}
                                    >
                                        {/* Previous */}
                                        <button
                                            onClick={() =>
                                                setCurrentPage((prev) =>
                                                    Math.max(prev - 1, 1)
                                                )
                                            }
                                            disabled={currentPage === 1}
                                            style={{
                                                border: "none",
                                                background: "transparent",
                                                color:
                                                    currentPage === 1
                                                        ? "#999"
                                                        : "#2ea4e7",
                                                cursor:
                                                    currentPage === 1
                                                        ? "not-allowed"
                                                        : "pointer",
                                                fontSize: "13px",
                                                padding: 0,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px",
                                                opacity:
                                                    currentPage === 1 ? 0.5 : 1,
                                            }}
                                        >
                                            <span style={{ fontSize: "20px" }}>‹</span>
                                            Previous
                                        </button>
 
                                        {/* Page Numbers */}
                                        {/* Page Numbers */}
 
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "20px",
                                            }}
                                        >
                                            {getPageNumbers(
                                                currentPage,
                                                totalPages
                                            ).map((pageNumber, index) => {
 
                                                // Dots
                                                if (pageNumber === "...") {
                                                    return (
                                                        <span
                                                            key={`ellipsis-${index}`}
                                                            style={{
                                                                fontSize: "13px",
                                                                color: "#444",
                                                            }}
                                                        >
                                                            ...
                                                        </span>
                                                    );
                                                }
 
                                                // Page Number
                                                return (
                                                    <button
                                                        key={pageNumber}
                                                        onClick={() =>
                                                            setCurrentPage(pageNumber)
                                                        }
                                                        style={{
                                                            border: "none",
                                                            background: "transparent",
                                                            padding: 0,
                                                            color:
                                                                currentPage === pageNumber
                                                                    ? "#2ea4e7"
                                                                    : "#444",
                                                            cursor: "pointer",
                                                            fontSize: "13px",
                                                            fontWeight:
                                                                currentPage === pageNumber
                                                                    ? "600"
                                                                    : "400",
                                                            textDecoration:
                                                                currentPage === pageNumber
                                                                    ? "underline"
                                                                    : "none",
                                                        }}
                                                    >
                                                        {pageNumber}
                                                    </button>
                                                );
                                            })}
                                        </div>
 
                                        {/* Next */}
                                        <button
                                            onClick={() =>
                                                setCurrentPage((prev) =>
                                                    Math.min(
                                                        prev + 1,
                                                        totalPages
                                                    )
                                                )
                                            }
                                            disabled={
                                                currentPage === totalPages ||
                                                totalPages === 0
                                            }
                                            style={{
                                                border: "none",
                                                background: "transparent",
                                                color:
                                                    currentPage === totalPages ||
                                                        totalPages === 0
                                                        ? "#999"
                                                        : "#2ea4e7",
                                                cursor:
                                                    currentPage === totalPages ||
                                                        totalPages === 0
                                                        ? "not-allowed"
                                                        : "pointer",
                                                fontSize: "13px",
                                                padding: 0,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px",
                                                opacity:
                                                    currentPage === totalPages ||
                                                        totalPages === 0
                                                        ? 0.5
                                                        : 1,
                                            }}
                                        >
                                            Next
                                            <span style={{ fontSize: "20px" }}>›</span>
                                        </button>
                                    </div>
                                </div>
 

                  </div>
                </div>
              </div>
            </div>
          </div>

          {rejectPanelhide === 2 && (
            <div
              className="col-12 RejectPanelContainer"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.35)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                className="Rejectpanel"
                style={{
                  width: "500px",
                  background: "#fff",
                  borderRadius: "10px",
                  padding: "20px",
                  boxShadow: "0 0 15px rgba(0,0,0,0.2)",
                }}
              >
                <form action="">
                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-3">
                        <label className="fw-bold">
                          Remark <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="col-8">
                        <textarea
                          name=""
                          id=""
                          placeholder="Enter Remark"
                          onChange={(e) => setRemark(e.target.value)}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="col-12 ms-auto my-4">
                  <div className="row">
                    {/* <div className="col-3"></div> */}
                    <div className="col-9 m-auto">
                      <div
                        className="col-12"
                        style={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            background:
                              "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                            width: "5rem",
                            height: "2rem",
                            fontSize: "18px",
                          }}
                          onClick={() => approveorrejectSelected("Rejected")}
                        >
                          <img src={submit} style={{ width: "15px" }} /> Reject
                        </button>
                        <button
                          type="button"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            backgroundColor: "#f1594c",
                            width: "6rem",
                            height: "2rem",
                            fontSize: "16px",
                          }}
                          onClick={() => window.location.reload()}
                        >
                          {" "}
                          <img src={Cancel32} style={{ width: "17px" }} />
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {rejectPanelhide === 3 && (
            <div
              className="col-12 RejectPanelContainer"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.35)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                className="Rejectpanel"
                style={{
                  width: "500px",
                  background: "#fff",
                  borderRadius: "10px",
                  padding: "20px",
                  boxShadow: "0 0 15px rgba(0,0,0,0.2)",
                }}
              >
                <form action="">
                  <div className="col-12 elements">
                    <div className="row">
                      <div className="col-3">
                        <label className="fw-bold">
                          Remark <span className="text-danger">*</span>
                        </label>
                      </div>
                      <div className="col-8">
                        <textarea
                          name=""
                          id=""
                          placeholder="Enter Remark"
                          onChange={(e) => setRemark(e.target.value)}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </form>
                {isChecker && (
                  <div className="col-12 ms-auto my-4">
                    <div className="row">
                      {/* <div className="col-3"></div> */}
                      <div className="col-9 m-auto">
                        <div
                          className="col-12"
                          style={{
                            display: "flex",
                            gap: "10px",
                            justifyContent: "center",
                          }}
                        >
                          <button
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "4px",
                              background:
                                "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                              width: "8rem",
                              height: "2rem",
                              fontSize: "18px",
                            }}
                            onClick={() => approveorrejectSelected("SendBack")}
                          >
                            <img src={submit} style={{ width: "15px" }} /> Send
                            Back
                          </button>
                          <button
                            type="button"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "4px",
                              backgroundColor: "#f1594c",
                              width: "6rem",
                              height: "2rem",
                              fontSize: "16px",
                            }}
                            onClick={() => window.location.reload()}
                          >
                            {" "}
                            <img src={Cancel32} style={{ width: "17px" }} />
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      ) : (
        <BudgetEstimation
          isEdit={true}
          BudgetEstimationData={editBudgetEstimationData}
          onSuccess={() => {
            setShowEditForm(false);
            BudgetEstimationList();
            setSelectedBills([]);
          }}
          onCancel={() => {
            setShowEditForm(false);
          }}
        />
      )}
    </>
  );
};

export default BudgetEstimationInwardList;
